import type { NonEmptyArray } from '@crossbeam/types';

export type ApiFilterFixtureType = {
  id: string;
  name: string;
  isCalculating: boolean;
};

export const API_FILTER_FIXTURES: NonEmptyArray<ApiFilterFixtureType> = [
  {
    id: '0409eecd-1236-474a-ac6b-4955814a0df2',
    name: 'Prospects → Customers',
    isCalculating: false,
  },
  {
    id: '0409ef3c-fc3f-44ed-9465-18be02d96331',
    name: 'Cosell',
    isCalculating: true,
  },
];
